import { http } from "./api";

export const servicesSuppliers = {
    // funcion para obtener los grupos de proveedores, tanto con id como sin id
    getSuppliersGroups: async (id = null) => {
        const endpoint = id
            ? `/v1/suppliers/groups/${id}`
            : "/v1/suppliers/groups/select-options";

        try {
            const response = await http.get(endpoint);

            if (response.requestCode === 200) {
                return {
                    success: true,
                    data: response.data,
                };
            }

            return {
                success: false,
                data: [],
            };
        } catch (error) {
            console.error("Error in getSuppliersGroups service:", error);
            return {
                success: false,
                data: [],
                message: "Error en la conexión con el servidor",
            };
        }
    },

    // Función para crear un nuevo grupo de proveedores
    createSupplierGroup: async (groupData) => {
        try {
            const response = await http.post("/v1/suppliers/groups", groupData);

            if (response.requestCode === 200 || response.requestCode === 201) {
                return {
                    success: true,
                    data: response.data,
                    message: "Grupo creado exitosamente",
                };
            }

            return {
                success: false,
                message: response.message || "Error al crear el grupo",
            };
        } catch (error) {
            console.error("Error in createSupplierGroup service:", error);
            return {
                success: false,
                message:
                    error.message || "Error en la conexión con el servidor",
            };
        }
    },

    // Función para actualizar un grupo de proveedores
    updateSupplierGroup: async (id, groupData) => {
        try {
            const response = await http.patch(
                `/v1/suppliers/groups/${id}`,
                groupData
            );

            if (response.requestCode === 200) {
                return {
                    success: true,
                    data: response.data,
                    message: "Grupo actualizado exitosamente",
                };
            }

            return {
                success: false,
                message: response.message || "Error al actualizar el grupo",
            };
        } catch (error) {
            console.error("Error in updateSupplierGroup service:", error);
            return {
                success: false,
                message:
                    error.message || "Error en la conexión con el servidor",
            };
        }
    },

    deleteSupplierGroup: async (id) => {
        try {
            const response = await http.delete(`/v1/suppliers/groups/${id}`);

            if (response.requestCode === 200) {
                return {
                    success: true,
                    message: "Grupo eliminado exitosamente",
                };
            }

            return {
                success: false,
                message: response.message || "Error al eliminar el grupo",
            };
        } catch (error) {
            console.error("Error in deleteSupplierGroup service:", error);
            return {
                success: false,
                message:
                    error.message || "Error en la conexión con el servidor",
            };
        }
    },

    getSuppliers: async (page = 1, perPage = 25, id, search = "") => {
        try {
            let url = `/v1/suppliers?page=${page}&limit=${perPage}`;

            if (id) {
                url += `&groupId=${id}`;
            }

            if (search && search.trim() !== "") {
                url += `&search=${encodeURIComponent(search.trim())}`;
            }

            const response = await http.get(url);

            if (response.requestCode === 200) {
                return {
                    success: true,
                    data: response.data,
                    message: "Proveedores obtenidos exitosamente",
                };
            } else if (response.requestCode === 404) {
                return {
                    success: true,
                    data: { data: [], meta: {} },
                    message: "No se encontraron proveedores",
                };
            }

            return {
                success: false,
                data: { data: [], meta: {} },
                message: response.message || "Error al obtener los proveedores",
            };
        } catch (error) {
            console.error("Error in getSuppliers service:", error);
            return {
                success: false,
                data: { data: [], meta: {} },
                message:
                    error.message || "Error en la conexión con el servidor",
            };
        }
    },

    // Función para crear un nuevo proveedor
    createSupplier: async (supplierData) => {
        try {
            // Si es FormData, usar configuración especial para multipart
            const isFormData = supplierData instanceof FormData;
            const config = isFormData
                ? {
                      headers: {
                          "Content-Type": "multipart/form-data",
                      },
                  }
                : {};

            const response = await http.post(
                "/v1/suppliers",
                supplierData,
                config
            );

            if (response.requestCode === 200 || response.requestCode === 201) {
                return {
                    success: true,
                    data: response.data,
                    message: "Proveedor creado exitosamente",
                };
            }

            return {
                success: false,
                message: response.message || "Error al crear el proveedor",
            };
        } catch (error) {
            console.error("Error in createSupplier service:", error);
            return {
                success: false,
                message:
                    error.message || "Error en la conexión con el servidor",
            };
        }
    },

    // Función para actualizar un proveedor
    updateSupplier: async (id, supplierData) => {
        try {
            // Si es FormData, usar configuración especial para multipart
            const isFormData = supplierData instanceof FormData;
            const config = isFormData
                ? {
                      headers: {
                          "Content-Type": "multipart/form-data",
                      },
                  }
                : {};

            const response = await http.patch(
                `/v1/suppliers/${id}`,
                supplierData,
                config
            );

            if (response.requestCode === 200) {
                return {
                    success: true,
                    data: response.data,
                    message: "Proveedor actualizado exitosamente",
                };
            }

            return {
                success: false,
                message: response.message || "Error al actualizar el proveedor",
            };
        } catch (error) {
            console.error("Error in updateSupplier service:", error);
            return {
                success: false,
                message:
                    error.message || "Error en la conexión con el servidor",
            };
        }
    },

    // Función para reordenar grupos de proveedores
    reorderSupplierGroups: async (items) => {
        try {
            const response = await http.put("/v1/suppliers/groups/reorder", {
                items,
            });

            if (response.requestCode === 200) {
                return {
                    success: true,
                    message: "Orden actualizado exitosamente",
                };
            }

            return {
                success: false,
                message: response.message || "Error al actualizar el orden",
            };
        } catch (error) {
            console.error("Error in reorderSupplierGroups service:", error);
            return {
                success: false,
                message:
                    error.message || "Error en la conexión con el servidor",
            };
        }
    },

    // Función para reordenar proveedores
    reorderSuppliers: async (items, groupId = null) => {
        try {
            const payload = { items };
            if (groupId) {
                payload.groupId = groupId;
            }

            const response = await http.put("/v1/suppliers/reorder", payload);

            if (response.requestCode === 200) {
                return {
                    success: true,
                    message: "Orden actualizado exitosamente",
                };
            }

            return {
                success: false,
                message: response.message || "Error al actualizar el orden",
            };
        } catch (error) {
            console.error("Error in reorderSuppliers service:", error);
            return {
                success: false,
                message:
                    error.message || "Error en la conexión con el servidor",
            };
        }
    },

    deleteSupplier: async (id) => {
        try {
            const response = await http.delete(`/v1/suppliers/${id}`);

            if (response.requestCode === 200 || response.requestCode === 204) {
                return {
                    success: true,
                    message: "Proveedor eliminado exitosamente",
                };
            }

            return {
                success: false,
                message: response.message || "Error al eliminar el proveedor",
            };
        } catch (error) {
            console.error("Error in deleteSupplier service:", error);
            return {
                success: false,
                message:
                    error.message || "Error en la conexión con el servidor",
            };
        }
    },
};
